import LocalizedStrings from 'localized-strings';

import { AccountClosureReason } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    subtitle: 'You can choose multiple reasons.',
    title: 'I am dissatisfied with Shine because…',
    [AccountClosureReason.UnsatisfiedBadSupportExperience]:
      'I had bad support experiences',
    [AccountClosureReason.UnsatisfiedBadBankingServiceExperience]:
      'I am not satisfied with the financial services offered (e.g. late transactions, check deposit, etc)',
    [AccountClosureReason.UnsatisfiedMissingBankingService]:
      'I need a banking service that you do not offer',
    [AccountClosureReason.UnsatisfiedMissingFeature]:
      'I need a feature that Shine doesn’t offer',
    [AccountClosureReason.UnsatisfiedOther]: 'Other',
    [AccountClosureReason.UnsatisfiedPricingIssue]:
      'I find the service too expensive',
    [AccountClosureReason.UnsatisfiedTechnicalIssue]:
      'I’m experiencing too many technical problems',
  },
  fr: {
    subtitle: 'Vous pouvez sélectionner plusieurs raisons.',
    title: 'Je suis mécontent·e de Shine car…',
    [AccountClosureReason.UnsatisfiedBadSupportExperience]:
      'J’ai eu une ou plusieurs mauvaises expériences avec le support client',
    [AccountClosureReason.UnsatisfiedBadBankingServiceExperience]:
      'Je ne suis pas satisfait·e des services financiers proposés (ex : opérations en retard, dépôt de chèque…)',
    [AccountClosureReason.UnsatisfiedOther]: 'Autre',
    [AccountClosureReason.UnsatisfiedMissingBankingService]:
      'J’ai besoin d’un service bancaire qui n’est pas proposé',
    [AccountClosureReason.UnsatisfiedMissingFeature]:
      'J’ai besoin d’une fonctionnalité qui n’est pas proposée',
    [AccountClosureReason.UnsatisfiedPricingIssue]:
      'Je trouve le service trop cher',
    [AccountClosureReason.UnsatisfiedTechnicalIssue]:
      'Je rencontre trop de problèmes techniques',
  },
});

export default locales;
